import { useState, useEffect } from "react";
import api from "../services/api";

export const useCakeAttributes = () => {
  const [attributeOptions, setAttributeOptions] = useState({
    decor: [],
    designPattern: [],
    texture: [],
  });
  const [disclaimerOptions, setDisclaimerOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const [decors, designPatterns, textures, disclaimers] =
          await Promise.all([
            api.get("/cake-attributes/decor"),
            api.get("/cake-attributes/style"),
            api.get("/cake-attributes/texture"),
            api.get("/disclaimers"),
          ]);
        setAttributeOptions({
          decor: decors.data,
          designPattern: designPatterns.data,
          texture: textures.data,
        });
        setDisclaimerOptions(disclaimers.data);
      } catch (error) {
        console.error("Failed to fetch attributes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAttributes();
  }, []);

  return { attributeOptions, disclaimerOptions, loading };
};
